import { Card, Center, Loader } from '@mantine/core';

export default function MainContentLoader() {
  return (
    <Card py="xl">
      <Center>
        <Loader />
      </Center>
    </Card>
  );
}
